import { useTranslate } from "ra-core";
import { useSearchParams } from "react-router";

import { cn } from "@/lib/utils";

import { ExpenseList } from "./ExpenseList";
import { RecurringExpenseList } from "./RecurringExpenseList";

/** Payables and the recurring templates generating them */
export const ExpensesView = () => {
  const translate = useTranslate();
  const [searchParams, setSearchParams] = useSearchParams();
  const isRecurring = searchParams.get("section") === "recurring";
  const tab = (recurring: boolean, label: string) => (
    <button
      type="button"
      onClick={() =>
        setSearchParams(recurring ? { section: "recurring" } : {}, {
          replace: true,
        })
      }
      aria-pressed={isRecurring === recurring}
      className={cn(
        "border-b-2 px-1 pb-1 text-sm font-medium",
        isRecurring === recurring
          ? "border-primary text-foreground"
          : "border-transparent text-muted-foreground hover:text-foreground",
      )}
    >
      {translate(label)}
    </button>
  );

  return (
    <div className="flex flex-col gap-3">
      <div className="flex gap-4 border-b">
        {tab(false, "crm.finance.expenses.title")}
        {tab(true, "crm.finance.recurring.title")}
      </div>
      {isRecurring ? <RecurringExpenseList /> : <ExpenseList />}
    </div>
  );
};
